import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progress-stepper',
  templateUrl: './progress-stepper.component.html',
  styleUrls: ['./progress-stepper.component.css']
})
export class ProgressStepperComponent implements OnInit {

  private documentList: Document[];
  private backgroundImage: string;
  private nodeList : Node[] = [];
  progress: Progress;
  @Input() set setDocumentList(doc:string){
    this.buildDocumentList(doc);
  }
  @Input() borderRadius:string;
  @Input() set progressChanged(progressValue: any){
    if (progressValue){
      this.progress.Nodes.forEach(node => {
        if (node.Order < this.progress.Nodes.find(x => x.Value == progressValue).Order){
          node.IsSelected = true;
        }
        else if (node.Order == this.progress.Nodes.find(x => x.Value == progressValue).Order){
          node.IsSelected = true;
        }
        else if (node.Order > this.progress.Nodes.find(x => x.Value == progressValue).Order){
          node.IsSelected = false;
        }
      });
    }
    
  }
  constructor() { }

  ngOnInit() {
  }

  buildDocumentList(dirtyList: string){
    // dirtyList = "(Bank:Compare)|(Doc:Additional Info)|LO:Accept Offer|";

    this.progress = JSON.parse(dirtyList);
    this.nodeList = this.progress.Nodes.filter(x => !x.IsHidden);
    // this.nodeList.forEach(element => {
    //   element.IsSelected = false;
    // });

    var i = 0;
    this.nodeList.forEach(node => {
      if (i > 0){
        if (!this.progress.Nodes[i - 1].IsSelected){
          node.DelayAmount = i;
        }
      }
      i++;
    });
    this.sortNodes();
  }

  sortNodes(){
    this.nodeList = this.nodeList.sort((a:Node,b:Node) => { 
      if(a.Order > b.Order){
        return 1;
      }else if(a.Order < b.Order){
        return -1;
      }else{
        return 0;
      }
     });
  }
}

export class Document {
  ImageName: string;
  Title: string;
  IsSelected: boolean;
  IsFullSelected: boolean;
}

export class Progress {
  Background: string;
  Nodes: Node[];
}

export class Node {
  Icon: string;
  IsHidden: boolean;
  IsSelected: boolean;
	Label: string;
  Order: number;
  Value: string;
  DelayAmount: number;
}
